export type IApplicationDocumentContainerRelation = {
  applicationId: number;
  documentContainerId: number;
};

export const ApplicationDocumentContainerDataUtil = {
  generateEntityKey: (args: Pick<IApplicationDocumentContainerRelation, "applicationId" | "documentContainerId">) =>
    `applicationId:${args.applicationId}|documentContainerId:${args.documentContainerId}`,
};
